import { render, staticRenderFns } from "./ConsiderVoluntaryPayments.vue?vue&type=template&id=57824944"
import script from "./ConsiderVoluntaryPayments.vue?vue&type=script&lang=js"
export * from "./ConsiderVoluntaryPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports